module.exports = __webpack_public_path__ + "static/media/item_15_5_comp.e19eaf3b.png";